import { Box, Button, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Styled metaform container
 */
export const FormContainer = styled(Box, {
  label: "metaform-container",
  shouldForwardProp: prop => prop !== "publicForm"
})<{ publicForm?: boolean }>(() => ({
  overflow: "auto"
}));

/**
 * Styled metaform layout
 */
export const FormLayout = styled(Box, {
  label: "metaform-container",
  shouldForwardProp: prop => prop !== "publicForm"
})<{ publicForm?: boolean }>(({ theme, publicForm }) => ({
  display: "flex",
  padding: publicForm ? "34px 24px 64px" : theme.spacing(2),
  justifyContent: "center"
}));

/**
 * Styled metaform body component
 */
export const MetaformBody = styled(Stack, {
  label: "metaform-body",
  shouldForwardProp: prop => prop !== "publicForm"
})<{ publicForm?: boolean }>(({ theme, publicForm }) => ({
  backgroundColor: publicForm ? "#fff" : undefined,
  border: publicForm ? "1px solid #e2e5e3" : undefined,
  borderRadius: publicForm ? 4 : undefined,
  boxSizing: "border-box",
  maxWidth: publicForm ? 760 : 800,
  flex: 1,
  marginInline: publicForm ? 0 : theme.spacing(4),
  padding: publicForm ? "30px 34px" : 0,
  "@media(max-width: 800px)": {
    marginInline: publicForm ? 0 : theme.spacing(2),
    padding: publicForm ? theme.spacing(2.5) : 0
  }
}));

/**
 * Styled metaform title component
 */
export const MetaformTitle = styled(Typography, {
  label: "metaform-title",
  shouldForwardProp: prop => prop !== "publicForm"
})<{ publicForm?: boolean }>(({ theme, publicForm }) => ({
  textAlign: publicForm ? "left" : "center",
  wordBreak: "break-word",
  fontSize: publicForm ? 24 : 36,
  fontWeight: publicForm ? 400 : "bold",
  color: theme.palette.text.primary,
  fontFamily: publicForm ? "inherit" : "Arial, sans-serif",
  lineHeight: publicForm ? 1.25 : undefined,
  marginBottom: theme.spacing(2),
  "@media(max-width: 510px)": {
    fontSize: publicForm ? 22 : 28
  }
}));

/**
 * Styled metaform section wrapper component
 */
export const MetaformSectionWrapper = styled(Box, {
  label: "metaform-section-wrapper",
  shouldForwardProp: prop => prop !== "publicForm"
})<{ publicForm?: boolean }>(({ theme, publicForm }) => ({
  padding: publicForm ? 0 : theme.spacing(2),
  marginBottom: publicForm ? 0 : theme.spacing(2),
  backgroundColor: publicForm ? "transparent" : theme.palette.secondary.light || "#fff",
  filter: publicForm ? "none" : "drop-shadow(0px 0px 10px rgba(0,0,0,0.05))"
}));

/**
 * Styled metaform field wrapper component
 */
export const MetaformFieldWrapper = styled(Box, {
  label: "metaform-field-wrapper",
  shouldForwardProp: prop => prop !== "publicForm"
})<{ publicForm?: boolean }>(({ theme, publicForm }) => ({
  marginBottom: publicForm ? theme.spacing(3.25) : theme.spacing(1),
  "& .metaform-field-help-container": publicForm ? {
    color: "#6e7472",
    fontSize: 13,
    lineHeight: "19px",
    marginBottom: theme.spacing(1)
  } : undefined
}));

/**
 * Styled metaform section component
 */
export const MetaformFieldset = styled(Stack, {
  label: "metaform-fieldset"
})(() => ({
  padding: 0,
  border: "none"
}));

/**
 * Styled round action button component
 */
export const RoundActionButton = styled(Button, {
  label: "round-action-button"
})(({ theme }) => ({
  borderRadius: "1em",
  fontWeight: "bold",
  height: "fit-content",
  padding: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
  alignSelf: "center"
}));